import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ExamAILazy = React.lazy(
	() => import(/* webpackChunkName : 'ExamAI' */ './components')
);

export default (store) => {
	return {
		path: 'exams/:examId/ai/:chatId',
		element: (
			<AsyncLoading
				component={
					<ExamAILazy featureFlag="FeatureFlag:ShowAIExamMarksUpload" />
				}
			/>
		),
	};
};
